import React , { useState , useEffect } from 'react';

import { Link , NavLink } from 'react-router-dom';
import menus from '../../pages/menu';
import dataSlider from '../../assets/fake-data/data-slider';

import './styles.scss';

const headerLogo = dataSlider.find((item) => item.id === 4)?.media;



const Header = () => {

    const [scroll, setScroll] = useState(false);
        useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 300);
        });
        return () => {
            setScroll({});
        }
    }, []);

    const [menuActive, setMenuActive] = useState(null);

    const handleMenuActive = () => {
        setMenuActive(!menuActive);
      };

    
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = index => {
        setActiveIndex(index); 
    };

    return (
        <header id="header_main" className={`header ${scroll ? 'is-fixed' : ''}`}>
            <div className="container">
                <div id="site-header-inner">
                    <div className="header__logo">
                        <NavLink to="/">
                            <img
                                src={headerLogo}
                                alt="Block Pirates logo"
                                loading="eager"
                            />
                        </NavLink>
                    </div>
                    <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`} >
                        <ul id="menu-primary-menu" className="menu">

                            {
                                menus.map((data,idx) => (
                                    <li key={idx} onClick={()=> handleDropdown(idx)} className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === idx ? 'active' : ''}`} 
                                    
                                    >
                                        <Link to={data.links}>{data.name}</Link>
                                        {
                                            data.namesub &&
                                            <ul className="sub-menu">
                                                {
                                                    data.namesub.map((submenu) => (
                                                        <li key={submenu.id} className="menu-item"><NavLink to={submenu.links}>{submenu.sub}</NavLink></li>
                                                    ))
                                                }
                                            </ul>
                                        }
                                        
                                    </li>
                                ))
                            }
                        </ul>

                        
                    </nav>

                              
                   



                    



                    <a className="header-marketplace" href="https://www.satflow.com/ordinals/blockpirates" target="_blank" rel="noreferrer">View on Satflaw</a>

                    <div className={`mobile-button ${menuActive ? 'active' : ''}`} onClick={handleMenuActive}><span></span></div>

 



                </div>

                
            </div>

            
        </header>
    );
}

export default Header;


/* Buttons ready to be redeployed between lines 70 and 75

 <div>  
                        
                        <a href="http://discord.gg/H2MB69HHty">
                        <button class="discordBtn">JOIN DISCORD </button>  </a>  
                        
                        </div>

                     
                    
                       <div>   <a href="https://twitter.com/Block_Pirates">
                        <button class="twitterBtn">Twitter </button> 

                        </a> </div>

                        

*/
